import { Component } from '@angular/core';
import { StarbaseModalOverlayService } from 'modal-overlay';
import { VoucherService } from 'scaletech-core';
import { StarbaseModalDialogService } from 'starbase-modal-dialog';
import { AppGlobalsService } from '../services/app-globals.service';
import { IEditCheck } from 'starbase-launcher';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-voucher-home',
  templateUrl: './voucher-home.html',
  styleUrl: './voucher-home.css',
  standalone: false
})
export class VoucherHomeComponent implements IEditCheck {
  public logoutConfirmationOpen = false;

  constructor(public voucherSvc: VoucherService,
              public overlaySvc: StarbaseModalOverlayService,
              public modalSvc: StarbaseModalDialogService,
              public appGlobals: AppGlobalsService,
              private appComp: AppComponent) { }

  unsavedChangesCheck() { return true; };

  exitVouchersHome() {
    this.overlaySvc.enableOverlay();
    this.logoutConfirmationOpen = true;
  }

  confirmLogOut() {
    this.overlaySvc.disableOverlay();
    this.logoutConfirmationOpen = false;
    this.appComp.logOut();
  }
}
